import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow, Typography, Paper,
  IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';

import moment from 'moment';
import { toast } from 'react-toastify';
import { IsEmpty } from '../../../common/checks';
import { usePromoCode } from '../../../hook/usePromoCode';
import { Status } from '../../../common/constants';
import UpdatePromoCodeModal from './UpdatePromoCodeModal';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function PromoCodeTable() {
  const classes = useStyles();
  const { filter, promoCodes, visiblePromoCodes, onFilterChange } = usePromoCode();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = useState(null);

  const onUpdateModalClose = () => {
    setIsModalOpen(false);
  };

  const handlePageChange = (e, value) => {
    onFilterChange({ pageNo: value });
  };

  const handlePageSizeChange = (e) => {
    onFilterChange({
      pageNo:   0, // Reset the page no to 0 if we change the pageSize
      pageSize: parseInt(e.target.value, 10),
    });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Gift ID</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Expiry Date</TableCell>
              <TableCell align="center">Created At</TableCell>
              <TableCell align="center">Last Updated At</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              !IsEmpty(visiblePromoCodes)
                ? visiblePromoCodes.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      {row.code}
                    </TableCell>
                    <TableCell>{row.giftId}</TableCell>
                    <TableCell align="center">{row.status}</TableCell>
                    <TableCell align="center">{moment(row.expiryDate).utcOffset('+08', false).format('DD MMM YYYY')}</TableCell>
                    <TableCell align="center">{moment(row.createdAt).utcOffset('+08', false).format('DD MMM YYYY, HH:mm:ss')}</TableCell>
                    <TableCell align="center">{moment(row.updatedAt).utcOffset('+08', false).format('DD MMM YYYY, HH:mm:ss')}</TableCell>
                    <TableCell align="center">
                      <IconButton
                        disabled={row.status !== Status.Unredeemed}
                        onClick={() => {
                          if (row.status === Status.Unredeemed) {
                            setIsModalOpen(true);
                            setSelectedPromoCode({
                              id:         row.id,
                              status:     row.status,
                              expiryDate: row.expiryDate,
                            });
                          }
                        }}
                      >
                        <Edit
                          style={{
                            cursor: 'pointer',
                            color:  (row.status === Status.Unredeemed) && 'black',
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
                : (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Typography className="text-center">No records to display</Typography>
                    </TableCell>
                  </TableRow>
                )
            }
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          colSpan={3}
          count={promoCodes.length}
          rowsPerPage={filter.pageSize}
          page={filter.pageNo}
          SelectProps={{
            inputProps: { 'aria-label': 'rows per page' },
            native:     true,
          }}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePageSizeChange}
          component="div"
        />
      </TableContainer>
      {
        selectedPromoCode && (
          <UpdatePromoCodeModal
            isModalOpen={isModalOpen}
            onClose={onUpdateModalClose}
            selectedPromoCode={selectedPromoCode}
            mode="Single"
            onComplete={() => {
              toast.success('Promo code updated successfully');
            }}
          />
        )
      }
    </>

  );
}

export default PromoCodeTable;
